import { assign, keys, pick } from "lodash";

export function updateBasicInfoSharedFields<T extends object, U extends object>(target: T, source: U): void {
  const newSource = pick(source, [ 'autoSummary', 'travelInfo', 'autoGenerated', 'pubDateString' ]);
  const shared = pick(newSource, keys(target));
  assign(target, shared);
};
